var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';

import Context from './context';

var LeverProvider = (_temp2 = _class = function (_PureComponent) {
  _inherits(LeverProvider, _PureComponent);

  function LeverProvider() {
    var _temp, _this, _ret;

    _classCallCheck(this, LeverProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      isDev: _this.props.isDev,
      features: _this.props.features
    }, _this.render = function () {
      var children = _this.props.children;

      return React.createElement(
        Context.Provider,
        { value: _this.state },
        children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LeverProvider;
}(PureComponent), _class.defaultProps = {
  isDev: false
}, _class.getDerivedStateFromProps = function (nextProps, prevState) {
  if (!_isEqual(nextProps.features, prevState.features)) {
    return {
      features: nextProps.features
    };
  }
  return null;
}, _temp2);
export { LeverProvider as default };
LeverProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  isDev: PropTypes.bool,
  features: PropTypes.object.isRequired
} : {};